import './app';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

const application = Application.start();

const sharedContext = require.context('./shared-controllers', true, /\.js$/);
application.load(definitionsFromContext(sharedContext));

const smartLearningContext = require.context('./smart-learning-controllers', true, /\.js$/);
application.load(definitionsFromContext(smartLearningContext));
